import {
  GET_CATEGORIES_SUBCATEGORIES_SUCCESS,
  GET_CATEGORIES_SUBCATEGORIES_FAIL,
  RESET_ERROR_AND_RESP,
  SET_TIMER,
  ADD_NEW_ITEM_SUCCESS,
  ADD_NEW_ITEM_FAIL,
  ADD_NEW_ITEM,
  ADD_NEW_MAJOR_ITEM,
  ADD_NEW_MAJOR_ITEM_SUCCESS,
  ADD_NEW_MAJOR_ITEM_FAIL,
  EDIT_ITEM,
  EDIT_ITEM_SUCCESS,
  EDIT_ITEM_FAIL,
  DELETE_ITEM,
  DELETE_ITEM_SUCCESS,
  DELETE_ITEM_FAIL,
  GET_HSNS_SUCCESS,
  GET_HSNS_FAIL,
  GET_UNITS_SUCCESS,
  GET_UNITS_FAIL,
  GET_ALLCOA_SUCCESS,
  GET_ALLCOA_FAIL,
  GET_ALL_PRODUCTS_SUCCESS,
  GET_ALL_PRODUCTS_FAIL,
  GET_PRODUCT_FOR_EDIT_SUCCESS,
  GET_PRODUCT_FOR_EDIT_FAIL,
  GET_MANUFACTURERS_SUCCESS,
  GET_MANUFACTURERS_FAIL,
  GET_TAXES_SUCCESS,
  GET_TAXES_FAIL,
  GET_BRANDS_SUCCESS,
  GET_BRANDS_FAIL,
  GET_SUPPLIERS_SUCCESS,
  GET_SUPPLIERS_FAIL,
  GET_ALL_CUSTOMERS_SUCCESS,
  GET_ALL_CUSTOMERS_FAIL,
  GET_ALL_EMPLOYEES_SUCCESS,
  GET_ALL_EMPLOYEES_FAIL,
  GET_ALL_BANKS_SUCCESS,
  GET_ALL_BANKS_FAIL,
  GET_SIZES_SUCCESS,
  GET_SIZES_FAIL,
  GET_COLOURS_SUCCESS,
  GET_COLOURS_FAIL,
  GET_SETTINGS,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAIL,
  GET_LEDGER_DETAILS_SUCCESS,
  GET_LEDGER_DETAILS_FAIL
} from "./actionTypes"

const INIT_STATE = {
  countdowntimer : 1500000, //25 minutes (25 * 60 * 1000)
  categories: [],
  suppliers:[],
  customers:[],
  employees:[],
  banks:[],
  brands: [],
  taxes: [],
  manufacturers:[],
  units: [],
  hsns: [],
  colours: [],
  sizes: [],
  products: [],
  settings: [],
  ledgers: [],
  error: {},
  response: {},
  product: {},
  addInProgress : false,
  addMajorInProgress : false,
  editInProgress : false,
  deleteInProgress : false,
  coaList:[],
  timelastextended: new Date().getTime()
}

const Product = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_CATEGORIES_SUBCATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload,
        countdowntimer : 1500000,
        timelastextended: new Date().getTime()
      }
    case GET_SIZES_SUCCESS:
      return {
        ...state,
        sizes: action.payload,
      }
    case GET_COLOURS_SUCCESS:
      return {
        ...state,
        colours: action.payload,
      }
    case GET_HSNS_SUCCESS:
      return {
        ...state,
        hsns: action.payload,
      }
    case GET_UNITS_SUCCESS:
      return {
        ...state,
        units: action.payload,
      }
    case GET_ALLCOA_SUCCESS:
      return {
        ...state,
        coaList: action.payload,
      }
    case GET_ALL_PRODUCTS_SUCCESS:
      return {
        ...state,
        products: action.payload,
        countdowntimer : 1500000,
        timelastextended: new Date().getTime()
      }
    case GET_PRODUCT_FOR_EDIT_SUCCESS:
      return {
        ...state,
        product: action.payload,
      }
    case GET_MANUFACTURERS_SUCCESS:
      return {
        ...state,
        manufacturers: action.payload,
      }
    case GET_TAXES_SUCCESS:
      return {
        ...state,
        taxes: action.payload,
      }
    case GET_BRANDS_SUCCESS:
      return {
        ...state,
        brands: action.payload,
      }
    case GET_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.payload,
        countdowntimer : 1500000,
        timelastextended: new Date().getTime()
      }
    case GET_LEDGER_DETAILS_SUCCESS:
      return {
        ...state,
        ledgers: action.payload,
      }
    case GET_SUPPLIERS_SUCCESS:
      return {
        ...state,
        suppliers: action.payload,
      }
    case GET_ALL_CUSTOMERS_SUCCESS:
      return {
        ...state,
        customers: action.payload,
        countdowntimer : 1500000,
        timelastextended: new Date().getTime()
      }
    case GET_ALL_EMPLOYEES_SUCCESS:
      return {
        ...state,
        employees: action.payload,
        countdowntimer : 1500000,
        timelastextended: new Date().getTime()
      }
    case GET_ALL_BANKS_SUCCESS:
      return {
        ...state,
        banks: action.payload,
        countdowntimer : 1500000,
        timelastextended: new Date().getTime()
      }
    case GET_HSNS_FAIL:
    case GET_UNITS_FAIL:
    case GET_ALLCOA_FAIL:
    case GET_ALL_PRODUCTS_FAIL:
    case GET_PRODUCT_FOR_EDIT_FAIL:
    case GET_MANUFACTURERS_FAIL:
    case GET_TAXES_FAIL:
    case GET_BRANDS_FAIL:
    case GET_SUPPLIERS_FAIL:
    case GET_CATEGORIES_SUBCATEGORIES_FAIL:
    case GET_SIZES_FAIL:
    case GET_COLOURS_FAIL:
    case GET_SETTINGS_FAIL:
    case GET_LEDGER_DETAILS_FAIL:
    case GET_ALL_CUSTOMERS_FAIL:
    case GET_ALL_EMPLOYEES_FAIL:
    case GET_ALL_BANKS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case ADD_NEW_ITEM_SUCCESS:
    return {
      ...state,
      response: action.payload,
      addInProgress: false
    }

    case ADD_NEW_ITEM_FAIL:
    return {
      ...state,
      error: action.payload,
      addInProgress: false
    }

    case SET_TIMER:
    return {
      ...state,
      countdowntimer : 1500000,
      timelastextended: new Date().getTime()
    }

    case RESET_ERROR_AND_RESP:
    return {
      ...state,
      error: {}, 
      response: {}
    }

    case ADD_NEW_ITEM:
    return {
      ...state,
      addInProgress: true,
      error: {},
    }

    case ADD_NEW_MAJOR_ITEM:
    return {
      ...state,
      addMajorInProgress: true,
      error: {},
    }

    case ADD_NEW_MAJOR_ITEM_SUCCESS:
    return {
      ...state,
      response: action.payload,
      addMajorInProgress: false
    }

    case ADD_NEW_MAJOR_ITEM_FAIL:
    return {
      ...state,
      error: action.payload,
      addMajorInProgress: false
    }

    case EDIT_ITEM:
    return {
      ...state,
      editInProgress: true,
      error: {},
    }

    case EDIT_ITEM_SUCCESS:
    return {
      ...state,
      response: action.payload,
      editInProgress: false
    }

    case EDIT_ITEM_FAIL:
    return {
      ...state,
      error: action.payload,
      editInProgress: false
    }

    case DELETE_ITEM:
    return {
      ...state,
      deleteInProgress: true,
      error: {},
    }

    case DELETE_ITEM_SUCCESS:
    return {
      ...state,
      response: action.payload,
      deleteInProgress: false
    }

    case DELETE_ITEM_FAIL:
    return {
      ...state,
      error: action.payload,
      deleteInProgress: false
    }

    default:
      return state
  }
}

export default Product
